module.exports = __webpack_public_path__ + "static/media/next-icon.84759524.svg";